import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";

export const RootRedirect = () => {
  const { session, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard
  if (session) {
    return <Navigate to="/dashboard" replace />;
  }

  // If user is not authenticated, redirect to landing page
  return <Navigate to="/landing" replace />;
};
